import * as React from "react";

import { ObservableValue } from "azure-devops-ui/Core/Observable";

import { Button } from "azure-devops-ui/Button";
import { ButtonGroup } from "azure-devops-ui/ButtonGroup";
import { Location } from "azure-devops-ui/Utilities/Position";
import { Observer } from "azure-devops-ui/Observer";
import { TeachingBubble } from "azure-devops-ui/TeachingBubble";

export default class SeriesTeachingBubbleExample extends React.Component {
    private activeBubble = new ObservableValue<number>(-1);
    private newWorkItemButtonRef = React.createRef<Button>();
    private openFilteredViewButtonRef = React.createRef<Button>();
    private columnOptionsButtonRef = React.createRef<Button>();

    private teachingBubbleProps: any[] = [];

    public render() {
        return (
            <>
                <ButtonGroup className="flex-row">
                    <div ref={this.callbackRef1} id="1">
                        <Button ref={this.newWorkItemButtonRef} text="New Work Item" />
                    </div>
                    <div ref={this.callbackRef2} id="2">
                        <Button ref={this.openFilteredViewButtonRef} text="Open filtered view in queries" />
                    </div>
                    <div ref={this.callbackRef3} id="3">
                        <Button ref={this.columnOptionsButtonRef} text="Column Options" />
                    </div>
                </ButtonGroup>
                <Observer activeBubble={this.activeBubble}>
                    {(props: { activeBubble: number }) => {
                        return props.activeBubble !== -1 ? (
                            <TeachingBubble
                                {...this.teachingBubbleProps[props.activeBubble]}
                                onDismiss={() => {
                                    const buttonRefs = [this.newWorkItemButtonRef, this.newWorkItemButtonRef, this.openFilteredViewButtonRef, this.columnOptionsButtonRef];
                                    const buttonToFocus = buttonRefs[props.activeBubble];
                                    if(buttonToFocus && buttonToFocus.current) {
                                        buttonToFocus.current.focus();
                                    }
                                    this.activeBubble.value = -1
                                }}
                            />
                        ) : null;
                    }}
                </Observer>
            </>
        );
    }

    private next = () => {
        if (this.activeBubble.value < this.teachingBubbleProps.length - 1) {
            this.activeBubble.value++;
        }
    };

    private previous = () => {
        if (this.activeBubble.value > 0) {
            this.activeBubble.value--;
        }
    };

    private nextButton = {
        text: "Next",
        onClick: this.next
    };

    private backButton = {
        text: "Previous",
        onClick: this.previous
    };

    private callbackRef1 = (element: HTMLDivElement) => {
        this.teachingBubbleProps.push({
            anchorElement: element,
            anchorOrigin: { horizontal: Location.start, vertical: Location.end },
            primaryButtonProps: this.nextButton,
            title: "Start with a work item",
            text: "Work items are the basic elements of a board. Create a new one to start."
        });
        this.teachingBubbleProps.push({
            anchorElement: element,
            anchorOrigin: { horizontal: Location.start, vertical: Location.end },
            primaryButtonProps: this.backButton,
            secondaryButtonProps: this.nextButton,
            title: "Start with a work item",
            text:
                "You have serveral different options for a work item such as a Bug, Feature, or User Story"
        });
        this.activeBubble.value = 0;
    };

    private callbackRef2 = (element: HTMLDivElement) => {
        this.teachingBubbleProps.push({
            anchorElement: element,
            anchorOrigin: { horizontal: Location.center, vertical: Location.end },
            primaryButtonProps: this.backButton,
            secondaryButtonProps: this.nextButton,
            title: "Creating a Query",
            text: "You can also create a Custom Query to filter your Work Items."
        });
    };

    private callbackRef3 = (element: HTMLDivElement) => {
        this.teachingBubbleProps.push({
            anchorElement: element,
            anchorOrigin: { horizontal: Location.end, vertical: Location.end },
            primaryButtonProps: this.backButton,
            title: "Modify what you see",
            text: "Add or remove columns or adjust the way Work Items are sorted."
        });
    };
}
